import { publicAxios } from '@/api/public-axios.ts';
import type { TAuthParams, TRegisterParams, TUser } from './auth.types.ts';
import { axios } from '@/api/axios.ts';

export const authApi = {
  login: async (data: TAuthParams) => {
    const response = await publicAxios.post('auth/login', data);

    return response.data;
  },
  logout: async () => {
    await publicAxios.post('auth/logout');
  },
  getCurrentUser: async () => {
    const response = await axios.get<TUser>('auth/status');

    return response.data;
  },
  register: async (data: TRegisterParams) => {
    const response = await publicAxios.post('auth/register', data);

    return response.data;
  },
  verifyEmail: async (token: string, password: string) => {
    const response = await publicAxios.patch(`auth/email-verification?token=${token}`, {
      password,
    });

    return response.data;
  },
  verifyEmailToken: async (token: string) => {
    const response = await publicAxios.get<string>(`auth/email-verification?token=${token}`);

    return response.data;
  },
  forgotPassword: async (email: string) => {
    const response = await publicAxios.post('auth/password/forgot', email);

    return response.data;
  },
  resendVerification: async (email: string) => {
    const response = await axios.post<{ success: boolean }>('auth/resend-verification', {
      email,
    });

    return response.data;
  },
  resetPassword: async (token: string, password: string) => {
    const response = await publicAxios.post(`auth/password/reset?token=${token}`, { password });

    return response.data;
  },
  verifyResetPasswordToken: async (token: string) => {
    const response = await publicAxios.get<string>(`auth/password/reset?token=${token}`);

    return response.data;
  },
};
